module.exports = __webpack_public_path__ + "fonts/LG_Smart_UI-Regular.a436751.woff";